import { Link } from "react-router-dom";
import logo from '../assets/logo-icon-white.svg';
import ExternalLink from './ExternalLink';

const Footer = ({ color }) => (
  <footer className={`footer center  bg bg-color-${color} bg-image-white text-color-white`}>
    <div className="footer-section">
      <p>
        Designed and handcrafted in New Orleans' Treme neighborhood
      </p>
      <p>
        Copyright{' '}
        <ExternalLink color="white" href="https://pafiu.me">
          Olivia Sabo-Rush
        </ExternalLink>
        <br />
        All rights reserved
      </p>
    </div>
    <Link to="/">
      <img src={logo} alt="Square icon logo" height="48px" />
    </Link>
  </footer>
);

export default Footer;

